import baseConfiguratorReducer from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import { ActionTypes } from './types';

import { RECEIVE_CONFIGURATION } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';

export default function configuratorReducer(state, action) {
  const code = action.data?.code;
  if (code === 403 || code === 401) {
    return {
      ...state,
      configuration: {
        ...state.configuration,
        customdata: {
          selectedAmounts: {},
        },
      },
    };
  }
  switch (action.type) {
    case ActionTypes.SET_CUSTOM_DATA: {
      const nextState = {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration.customdata,
            ...action.payload,
          },
        },
      };
      return updateCoolingWaterTemperatureFields(nextState);
    }
    case ActionTypes.RESET_CONFIGURATION: {
      return baseConfiguratorReducer(state, {
        type: RECEIVE_CONFIGURATION,
        data: {
          item: {},
          optionclassifications: [],
        },
      });
    }
    case RECEIVE_CONFIGURATION: {
      const { configuration } = state;
      // if the configuration is loaded from the server, do not keep the customdata
      const customdata = configuration.code ? {} : { ...configuration.customdata };
      const nextState = baseConfiguratorReducer(state, action);

      // remove appState from the configuration (so it does not travel with it unnecessarily)
      delete customdata.appState;

      return {
        ...nextState,
        configuration: {
          ...nextState.configuration,
          customdata: {
            ...nextState.configuration.customdata,
            ...customdata,
          },
        },
      };
    }
    default: {
      return baseConfiguratorReducer(state, action);
    }
  }
}

const updateCoolingWaterTemperatureFields = (state) => {
  const customdata = { ...state.configuration.customdata };
  const coolingZoneAmount = customdata?.selectedAmounts?.[state.configuration.item.identifier];
  const coolingWaterTemperatureFields = Object.keys(customdata).filter((key) =>
    key.endsWith('_available_cooling_water_temperature')
  );
  if (coolingZoneAmount && coolingWaterTemperatureFields.length < coolingZoneAmount) {
    for (let i = coolingWaterTemperatureFields.length; i < coolingZoneAmount; i++) {
      customdata[`cooling_zone_${i + 1}_available_cooling_water_temperature`] = '';
    }
  } else if (coolingZoneAmount && coolingWaterTemperatureFields.length > coolingZoneAmount) {
    for (let i = coolingWaterTemperatureFields.length; i > coolingZoneAmount; i--) {
      delete customdata[`cooling_zone_${i}_available_cooling_water_temperature`];
    }
  }
  return {
    ...state,
    configuration: {
      ...state.configuration,
      customdata,
    },
  };
};
